import { render, staticRenderFns } from "./physiologyGraphicAvgStudentJump.vue?vue&type=template&id=05d0543c&"
import script from "./physiologyGraphicAvgStudentJump.js?vue&type=script&lang=js&"
export * from "./physiologyGraphicAvgStudentJump.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports